import { render } from "./inseratCard.vue?vue&type=template&id=78432866&scoped=true"
import script from "./inseratCard.vue?vue&type=script&lang=js"
export * from "./inseratCard.vue?vue&type=script&lang=js"

import "./inseratCard.vue?vue&type=style&index=0&id=78432866&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78432866"

export default script